import React from "react";
import { Column, ColumnId } from ".";
import base from "./base";
import ExecutingStageArrivedTimeCellContent from "../components/ExecutingStageArrivedTimeCellContent";

function executingStageArrivedTime({ width, onResize }: Column.Options) {
	return base(
		ColumnId.ExecutingStageArrivedTime,
		(item) => <ExecutingStageArrivedTimeCellContent item={item} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default executingStageArrivedTime;
